module.exports = __webpack_public_path__ + "static/img/green-circle.c91a101.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/green-circle.svg
// module id = 1431
// module chunks = 0